var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.label}},[_c('icon-help-circle-outline',{staticClass:"text-gray-500",attrs:{"width":"16","height":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }